// #region CONSTANTES
export const BASE_URL = (process.env.NODE_ENV === "production") ? "https://www.idsoft.net/modsiteids" : "http://127.0.0.1/modsiteids";
// #endregion